(function () {
	'use strict';

	angular
		.module('uwAgenda.settings.grouppractice')
		.controller('GroupPracticeDetailController', GroupPracticeDetailControllerFn);
	
	GroupPracticeDetailControllerFn.$inject = [
        'grouppractice',
        'Alert', 
        'GroupPracticeService',
        '$uibModalInstance',
		'$translate'];

	function GroupPracticeDetailControllerFn(
        grouppractice,
        Alert, 
        GroupPracticeService,
        $uibModalInstance,
		$translate
    ) {
		var vm = this;
		
		vm.grouppractice = grouppractice;

		vm.save = function () {
			
			// save or update
			if (vm.grouppractice.id > 0) {
				// update
				GroupPracticeService.updateGroupPractice(
						vm.grouppractice
					).then(function() {
						Alert.success($translate.instant('grouppractice_updated'));
						$uibModalInstance.close();
					});				
			} 
			else {
				// save
				GroupPracticeService.createGroupPractice(
					vm.grouppractice
				).then(function() {
					Alert.success($translate.instant('grouppractice_created'));
					$uibModalInstance.close();
				});				
			}
		};

		// close modal
		vm.abort = function () {
			$uibModalInstance.dismiss();
		};	
	}
})();